import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Input } from 'reactstrap';
import CurrencyFormat from 'react-currency-format';
import VFMGSlider from './VFMGSlider'; // Import the existing component

const FootAndTermInput = ({
                              // Foot/Down Payment Props
                              foot,
                              footClean,
                              pieMinInt,
                              pieMaxInt,
                              messageFoot,
                              loadingFee,
                              onChangeFoot,

                              // Term Selector Props
                              term,
                              listPlazos = [],
                              onChangePlazo,

                              // VFMG Slider Props
                              businessType,
                              vfmg,
                              handleChangeVFMG,
                              allFees
                          }) => {

    return (
        <Row className="mt-4">
            {/* Foot/Down Payment Input - Left Column */}
            <Col>
                <div className="form-group">
                    <label className="labe-simulation-home" htmlFor="foot">Pie</label>
                    <CurrencyFormat
                        name="foot"
                        className="form-control"
                        onChange={(e) => onChangeFoot(e.target.value)}
                        onBlur={(e) => {
                            let value = e.target.value.replaceAll(/[.$]/g, "");
                            value = Number.parseInt(value || 0);
                            if (value > pieMaxInt) {
                                onChangeFoot(pieMaxInt);
                            } else if (value < pieMinInt) {
                                onChangeFoot(pieMinInt);
                            }
                        }}
                        value={foot}
                        decimalSeparator=","
                        thousandSeparator="."
                        prefix={"$"}
                        disabled={loadingFee}
                        id="foot"
                        placeholder="Ingrese el pie"
                        required
                        maxLength={16}
                        aria-label="Monto del pie"
                        aria-describedby={messageFoot ? "foot-error" : undefined}
                    />
                    {messageFoot && (
                        <div id="foot-error" className="text-danger small mt-1">
                            {messageFoot}
                        </div>
                    )}
                </div>

                {/* Foot Range Slider */}
                <div className="mt-4 mb-4 col-11 px-0 sf-range-container">
                    <Input
                        id="foot-range"
                        className="sf-range"
                        type="range"
                        min={pieMinInt}
                        max={pieMaxInt}
                        value={Number.parseInt(footClean) || pieMinInt}
                        onChange={(e) => {
                            const value = Number.parseInt(e.target.value);
                            onChangeFoot(value);
                        }}
                        disabled={loadingFee}
                        aria-label="Rango del pie"
                    />
                </div>
            </Col>

            {/* VFMG Slider - Middle Column (only for Auto Renuévate) */}
            {businessType === "1" && (
                <Col>
                    <VFMGSlider
                        handleChangeVFMG={handleChangeVFMG}
                        loading={loadingFee}
                        allFees={allFees}
                        vfmg={vfmg}
                        fee={term}
                    />
                </Col>
            )}

            {/* Term Selector - Right Column */}
            <Col>
                <div className="form-group">
                    <label className="labe-simulation-home" htmlFor="term">Plazo</label>
                    <select
                        required
                        onChange={onChangePlazo}
                        value={term}
                        disabled={loadingFee}
                        id="term"
                        name="term"
                        className="form-control"
                        aria-label="Selección de plazo"
                    >
                        <option value="">Seleccione el plazo</option>
                        {listPlazos.map((plazo) => (
                            <option
                                key={`plazo-${plazo.Plazo}`}
                                value={plazo.Plazo}
                                disabled={!plazo.PlazoVigencia}
                            >
                                {plazo.Plazo}
                            </option>
                        ))}
                    </select>
                </div>
            </Col>
        </Row>
    );
};

// PropTypes
FootAndTermInput.propTypes = {
    // Foot/Down Payment Props
    foot: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    footClean: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    pieMinInt: PropTypes.number.isRequired,
    pieMaxInt: PropTypes.number.isRequired,
    messageFoot: PropTypes.string,
    loadingFee: PropTypes.bool,
    onChangeFoot: PropTypes.func.isRequired,

    // Term Selector Props
    term: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    listPlazos: PropTypes.arrayOf(
        PropTypes.shape({
            Plazo: PropTypes.number.isRequired,
            PlazoVigencia: PropTypes.bool.isRequired,
            RANGOVFMG: PropTypes.shape({
                Minimo: PropTypes.number,
                Maximo: PropTypes.number
            })
        })
    ),
    onChangePlazo: PropTypes.func.isRequired,

    // VFMG Slider Props
    businessType: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    vfmg: PropTypes.number,
    handleChangeVFMG: PropTypes.func,
    allFees: PropTypes.array
};

// Default Props
FootAndTermInput.defaultProps = {
    foot: '',
    footClean: 0,
    messageFoot: '',
    loadingFee: false,
    listPlazos: [],
    businessType: '',
    vfmg: 0,
    allFees: []
};

export default FootAndTermInput;